import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import * as yup from 'yup';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';

import { Button } from '../../../shared/components/Button/Button';
import { FormattedProps } from '../types';
import {
  ButtonsWrapper,
  Form,
  Heading,
  Raw,
  Wrapper
} from '../styles/components';
import { CustomTitle } from 'shared/components/presentational/Title/sharedTitles';
import InputField from 'shared/components/presentational/Form/Fields/InputField';
import AlertBox from 'shared/components/presentational/AlertBox/AlertBox';
import ResponsiveHoc, {
  ResponsiveHocProps
} from 'shared/components/presentational/ResponsiveHOC/ResponsiveHoc';
import { ADD_RENEWAL_NUMBER } from '../../reducer';

function Login({
  title,
  subtitle,
  renewalNumberInputLabel,
  submitButton,
  previousButton,
  mediaQueries
}: FormattedProps & ResponsiveHocProps) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  if (mediaQueries.toPhone === false) {
    return (
      <Wrapper>
        <AlertBox
          status="info"
          content={t('blocks.updatingOptions.onlyMobile')}
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Heading>
        {title && (
          <CustomTitle htmlTag={title.htmlTag}>{title.label}</CustomTitle>
        )}
        {subtitle && <Raw html={subtitle} />}
      </Heading>

      <Formik
        initialValues={{ renewalNumber: '' }}
        validationSchema={yup.object().shape({
          renewalNumber: yup
            .string()
            .required(
              t('blocks.updatingOptions.login.validation.renewalNumber')
            )
        })}
        onSubmit={values => {
          const params = new URLSearchParams({
            renewalNumber: values.renewalNumber
          });

          dispatch({
            type: ADD_RENEWAL_NUMBER,
            payload: { renewalNumber: values.renewalNumber }
          });
          history.push(`${submitButton.link}?${params.toString()}`);
        }}
      >
        <Form>
          <div>
            <Field
              component={InputField}
              name="renewalNumber"
              type="text"
              placeholder={renewalNumberInputLabel}
            />
          </div>

          <ButtonsWrapper>
            <Button
              type="submit"
              label={submitButton.label}
              variant="primary"
              fullWidthMobile
            />

            {previousButton && previousButton.link && (
              <Button
                label={previousButton.label}
                variant="secondary"
                fullWidthMobile
                link={previousButton.link}
              />
            )}
          </ButtonsWrapper>
        </Form>
      </Formik>
    </Wrapper>
  );
}

export default ResponsiveHoc(Login);
